var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import { getCPFFormatado } from '../../../utils';
import { PAGINAS } from '../../../routes';
import { BotaoAdicionarSemAcao } from '../../../components/botoes';
import BarraPesquisar from '../../../components/grid_pesquisar';
import Grid, { PaginationModelDefault } from '../../../components/grid';
import { BoxPrincipal, BoxSuperior, BoxGrid } from '../../../components/grid_box';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getReeducandos, STATUS_API } from './reeducandos_service';
import ContainerModal from '../../../components/container_modal';
export var ReeducandosBusca = function (_a) {
    var _b = _a.DisponibilidadeContratacaoBusca, DisponibilidadeContratacaoBusca = _b === void 0 ? true : _b, selecionarReeducando = _a.selecionarReeducando, _c = _a.selecaoMultipla, selecaoMultipla = _c === void 0 ? false : _c, limiteSelecao = _a.limiteSelecao, _d = _a.reeducandosSelecionados, reeducandosSelecionados = _d === void 0 ? [] : _d, confirmarSelecao = _a.confirmarSelecao, fecharDialog = _a.fecharDialog;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(true), isLoadingInicio = _f[0], setIsLoadingInicio = _f[1];
    var _g = useState(''), TextoBusca = _g[0], setTextoBusca = _g[1];
    var _h = useState([]), Reeducandos = _h[0], setReeducandos = _h[1];
    var _j = useState(reeducandosSelecionados.map(function (item) { return item.id; })), Selecao = _j[0], setSelecao = _j[1];
    var _k = useState(reeducandosSelecionados.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.id] = item, _a)));
    }, {})), ReeducandosMarcados = _k[0], setReeducandosMarcados = _k[1];
    var _l = useState(0), TotalRegistros = _l[0], setTotalRegistros = _l[1];
    var _m = useState(PaginationModelDefault), PaginationModel = _m[0], setPaginationModel = _m[1];
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PaginationModel]);
    useEffect(function () {
        if (isLoadingInicio) {
            setIsLoadingInicio(false);
        }
        else {
            setPaginationModel(function (prevPaginationModel) {
                return __assign(__assign({}, prevPaginationModel), { page: 0 });
            }); //dispara o useEffect que carrega os dados
        }
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [TextoBusca]);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta, dados, total_registros;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getReeducandos(TextoBusca == '' ? null : TextoBusca, 'Ativo', null, DisponibilidadeContratacaoBusca, PaginationModel)];
                case 1:
                    Resposta = _a.sent();
                    if (Resposta.Status == STATUS_API.ERRO) {
                        enqueueSnackbar(Resposta.Mensagem, {
                            variant: 'error',
                            anchorOrigin: { vertical: 'top', horizontal: 'center' },
                            autoHideDuration: 3000,
                        });
                        fecharDialog === null || fecharDialog === void 0 ? void 0 : fecharDialog();
                    }
                    else {
                        dados = Resposta.dados, total_registros = Resposta.total_registros;
                        setReeducandos(dados);
                        setTotalRegistros(total_registros);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onPaginationModelChange = function (PaginationModelParm) {
        setPaginationModel(PaginationModelParm);
    };
    var alterarSelecao = function (idsSelecionados) {
        if (limiteSelecao && idsSelecionados.length > limiteSelecao) {
            alert("Selecione no m\u00E1ximo ".concat(limiteSelecao, " colaborador").concat(limiteSelecao > 1 ? 'es' : '', "."));
            return;
        }
        var idsNumericos = idsSelecionados.map(function (id) { return Number(id); });
        var marcadosAtualizados = __assign({}, ReeducandosMarcados);
        Reeducandos.forEach(function (reeducando) {
            if (idsNumericos.includes(reeducando.id)) {
                marcadosAtualizados[reeducando.id] = reeducando;
            }
        });
        Object.keys(marcadosAtualizados).forEach(function (id) {
            if (!idsNumericos.includes(Number(id))) {
                delete marcadosAtualizados[Number(id)];
            }
        });
        setSelecao(idsSelecionados);
        setReeducandosMarcados(marcadosAtualizados);
    };
    var confirmarReeducandosMarcados = function () {
        var marcados = Object.values(ReeducandosMarcados);
        if (!marcados.length) {
            alert('Selecione ao menos um colaborador.');
            return;
        }
        confirmarSelecao === null || confirmarSelecao === void 0 ? void 0 : confirmarSelecao(marcados);
    };
    var getColunasFuncionalidade = function (Tipo) { return [
        {
            field: 'id',
            headerName: 'Código',
            width: 150,
            valueGetter: function (_value, row) { return "FUNAC - ".concat(row.id); },
        },
        {
            field: 'nome',
            headerName: 'Nome',
            width: 300,
            valueGetter: function (_value, row) { return (Tipo === 'ADD' ? row.nome : row.reeducando.nome); },
        },
        {
            field: 'cpf',
            headerName: 'CPF',
            width: 150,
            valueGetter: function (_value, row) { return "".concat(getCPFFormatado(Tipo === 'ADD' ? row.cpf : row.reeducando.cpf)); },
        },
        {
            field: 'regime_pena',
            headerName: 'Tipo de Regime',
            width: 150,
            valueGetter: function (_value, row) { var _a, _b, _c; return (Tipo === 'ADD' ? (_a = row.regime_reclusao_atual) === null || _a === void 0 ? void 0 : _a.nome : (_c = (_b = row.reeducando) === null || _b === void 0 ? void 0 : _b.regime_reclusao_atual) === null || _c === void 0 ? void 0 : _c.nome); },
        },
        {
            field: 'disponivel_para_contratacao',
            headerName: 'Disponível para Contratação',
            width: 250,
            valueGetter: function (_value, row) { return "".concat(row.disponivel_para_contratacao ? 'Sim' : 'Não'); },
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) {
                var isAddAction = Tipo === 'ADD';
                var tooltipTitle = isAddAction ? 'Adicionar Colaborador' : 'Remover Colaborador';
                var buttonColor = isAddAction ? 'terceary.main' : 'error.main';
                var IconComponent = isAddAction ? CheckOutlinedIcon : CloseOutlinedIcon;
                return (_jsx(Tooltip, __assign({ title: tooltipTitle, componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: buttonColor, style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () {
                                selecionarReeducando(params.row);
                            } }, { children: _jsx(IconComponent, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })));
            },
        },
    ]; };
    var cadastrarNovoReeducando = function () {
        window.open('/painel/recrutamentos/cadastrar', '_blank');
    };
    var COLUNAS_ADICIONAR = selecaoMultipla ? getColunasFuncionalidade('ADD').filter(function (coluna) { return coluna.field != 'Opções'; }) : getColunasFuncionalidade('ADD');
    return (_jsx(ContainerModal, __assign({ pagina: PAGINAS.REEDUCANDOS_BUSCA }, { children: _jsxs(BoxPrincipal, __assign({ mt: 5 }, { children: [_jsxs(Box, __assign({ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }, { children: [_jsx(BotaoAdicionarSemAcao, { style: { marginBottom: 10 }, onClick: cadastrarNovoReeducando }), selecaoMultipla && (_jsx(Button, __assign({ variant: 'contained', color: 'primary', style: { marginBottom: 10, marginLeft: 10 }, onClick: confirmarReeducandosMarcados }, { children: "Adicionar selecionados" }))), _jsx(IconButton, __assign({ style: { marginBottom: 10 }, onClick: carregarDados }, { children: _jsx(RefreshIcon, {}) }))] })), _jsx(BoxSuperior, { children: _jsx(BarraPesquisar, { filtrarGrid: setTextoBusca }) }), _jsx(BoxGrid, { children: _jsx(Grid, { columns: COLUNAS_ADICIONAR, rows: Reeducandos, TotalRegistros: TotalRegistros, isLoading: isLoading, PaginationModel: PaginationModel, setPaginationModel: onPaginationModelChange, checkboxSelection: selecaoMultipla, keepNonExistentRowsSelected: selecaoMultipla, rowSelectionModel: selecaoMultipla ? Selecao : undefined, onRowSelectionModelChange: selecaoMultipla ? alterarSelecao : undefined }) })] })) })));
};
export default ReeducandosBusca;
